import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useFactsheetDownload = () => {
  const [loading, setLoading] = useState(false);

  const downloadFactsheet = async (portfolio: string) => {
    try {
      setLoading(true);
      
      const { data, error } = await supabase.functions.invoke('factsheet-manager', {
        body: { 
          action: 'get_download_url',
          portfolio: portfolio.toUpperCase()
        }
      });

      if (error) throw error;

      if (data.downloadUrl) {
        // Open factsheet in a new tab
        window.open(data.downloadUrl, '_blank');
        
        toast.success('Factsheet opened in new tab');
      } else {
        toast.error('Factsheet not available for download');
      }
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download factsheet');
    } finally {
      setLoading(false);
    }
  };

  const updateFactsheet = async (portfolio: string, driveFileId: string, fileName: string) => {
    try {
      setLoading(true);
      
      const { data, error } = await supabase.functions.invoke('factsheet-manager', {
        body: { 
          action: 'download',
          portfolio: portfolio.toUpperCase(),
          driveFileId,
          fileName
        }
      });

      if (error) throw error;

      if (data.success) {
        toast.success('Factsheet updated successfully');
      } else {
        toast.error('Failed to update factsheet');
      }
    } catch (error) {
      console.error('Update error:', error);
      toast.error('Failed to update factsheet');
    } finally {
      setLoading(false);
    }
  };

  return {
    downloadFactsheet,
    updateFactsheet,
    loading
  };
};